<template>
    <div class="publication__section content-width">

        <div class="publication__section-row d-flex">

            <div class="publication__section-inner publication__section-inner--third d-flex">
                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('publication_personal_gender')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in initial.gender">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.gender.$model" :value="item.value">
                                <span class="circle"></span>
                                {{$store.getters.t(item.value === 'male' ? 'pet_info_gender_male' : 'pet_info_gender_female')}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.gender.$error">{{$store.getters.t('publication_pet_profile_enter_gender')}}</div>
                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('publication_personal_age')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in initial.pet_age_category_id">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.pet_age_category_id.$model" :value="item.id">
                                <span class="circle"></span>
                                {{item.name}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.pet_age_category_id.$error">{{$store.getters.t('publication_pet_profile_enter_age')}}</div>
                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('pet_info_size_label')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in initial.size">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.size.$model" :value="key">
                                <span class="circle"></span>
                                {{value}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.size.$error">{{$store.getters.t('publication_pet_profile_enter_size')}}</div>
                </div>
            </div>


        </div>

        <div class="publication__section-row d-flex">

            <div class="publication__section-inner publication__section-inner--third d-flex">

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('pet_info_vaccinated')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in initial.default_temp">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.is_vaccinated.$model" :value="item.value">
                                <span class="circle"></span>
                                {{$store.getters.t(item.value ? 'volunteer_backend_settings_component_yes' : 'volunteer_backend_settings_component_no')}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.is_vaccinated.$error">{{$store.getters.t('common_invalid_value')}}</div>
                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('publication_personal_is_caught')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in initial.default_temp">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.is_catch.$model" :value="item.value">
                                <span class="circle"></span>
                                {{$store.getters.t(item.value ? 'volunteer_backend_settings_component_yes' : 'volunteer_backend_settings_component_no')}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.is_catch.$error">{{$store.getters.t('common_invalid_value')}}</div>
                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('publication_personal_is_invalid')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in initial.default_temp">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.is_invalid.$model" :value="item.value">
                                <span class="circle"></span>
                                {{$store.getters.t(item.value ? 'volunteer_backend_settings_component_yes' : 'volunteer_backend_settings_component_no')}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.is_invalid.$error">{{$store.getters.t('common_invalid_value')}}</div>
                </div>

            </div>

            <div class="publication__section-inner">

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('pet_info_parasite_treatment')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in initial.default_temp">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.is_parasite_treatment.$model" :value="item.value">
                                <span class="circle"></span>
                                {{$store.getters.t(item.value ? 'volunteer_backend_settings_component_yes' : 'volunteer_backend_settings_component_no')}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.is_parasite_treatment.$error">{{$store.getters.t('common_invalid_value')}}</div>
                </div>

            </div>

            <div class="publication__section-inner">

                <div class="publication__section-item">
                    <div class="publication__section-title">{{$store.getters.t('pet_info_sterilized')}}</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="item in initial.default_temp">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.is_sterilized.$model" :value="item.value">
                                <span class="circle"></span>
                                {{$store.getters.t(item.value ? 'volunteer_backend_settings_component_yes' : 'volunteer_backend_settings_component_no')}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.is_sterilized.$error">{{$store.getters.t('common_invalid_value')}}</div>
                </div>

            </div>

        </div>


    </div>
</template>

<script>


const initialData = {
    gender:         [ { value: 'male', name: 'Мальчик' }, { value: 'female', name: 'Девочка' } ],
    default_temp:   [ { value: 1, name: 'Да' }, { value: 0, name: 'Нет' } ],
}

import { required } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PetProfile",
    props: ['server'],
    mixins: [StateMixin],

    computed: {

        initial(){
            return  (
                {
                    ...initialData,
                    pet_age_category_id: this.server.dictionaries.pet_age_category_id,
                    size: this.server.dictionaries.size
                }
            )
        },

        gender:{
            get(){ return this.GET_BY_KEY('gender') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'gender', data: val })
            }
        },

        pet_age_category_id:{
            get(){ return this.GET_BY_KEY('pet_age_category_id') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'pet_age_category_id', data: val })
            }
        },

        size:{
            get(){ return this.GET_BY_KEY('size') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'size', data: val })
            }
        },

        is_vaccinated:{
            get(){ return this.GET_BY_KEY('is_vaccinated') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'is_vaccinated', data: val })
            }
        },

        is_invalid:{
            get(){ return this.GET_BY_KEY('is_invalid') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'is_invalid', data: val })
            }
        },

        is_catch:{
            get(){ return this.GET_BY_KEY('is_catch') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'is_catch', data: val })
            }
        },

        is_parasite_treatment:{
            get(){ return this.GET_BY_KEY('is_parasite_treatment') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'is_parasite_treatment', data: val })
            }
        },

        is_sterilized:{
            get(){ return this.GET_BY_KEY('is_sterilized') },
            set( val ){
                this.SET_PET_BY_KEY({ key: 'is_sterilized', data: val })
            }
        },



    },

    methods: {

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }
    },

    validations: {

        gender:                { required },
        pet_age_category_id:   { required },
        size:                  { required },
        is_vaccinated:         { required },
        is_invalid:            { required },
        is_catch:              { required },
        is_parasite_treatment: { required },
        is_sterilized:         { required },

    }

}
</script>

<style scoped>

</style>
